import React, { useEffect, useState } from 'react';

import api from '../api';
import ComingSoon from '../Components/ComingSoon';
import Drop from '../Components/Drop';
import sticker from '../assets/initial_commit_sticker.png';

const INITIAL_COMMIT = {
  eyebrow: 'LIMITED EDITION · DROP 001',
  title: <>The <span className='text-commit-gold'>Initial Commit</span> Sticker</>,
  kicker: 'Every new repository starts the same way: a default message that simply says "Initial Commit." This one marks that exact moment for Code Scribes.',
  // The ScribeCards trial is the one benefit with a number attached, because
  // the launch post names it and a buyer arriving from that post has to find
  // the same promise here. Everything after it stays open-ended on purpose:
  // nothing knows who holds a sticker beyond the Stripe buyer list, so every
  // one of these is honoured by hand -- fine at 500, and the reason the rest
  // promises an announcement rather than a rate or a duration.
  perk: 'Initial Commit Sticker holders get a 3-month free trial of ScribeCards, plus free trials and early access to educational content as Code Scribes grows. New merch drops are always announced to Initial Commit sticker holders first.',
  price: '$5.00',
  // Only the fallback shown when the counter can't load. Keep it equal to the
  // payment link's limit in Stripe.
  runSize: 500,
  image: sticker,
  imageAlt: 'The Code Scribes Initial Commit die-cut vinyl sticker',
  commit: {
    // The real first commit in this repo. The audience for this sticker reads
    // SHAs for a living, and the placeholder that used to be here was
    // sequential hex that no hash would ever look like.
    hash: 'e1e8e88',
    refs: 'tag: v0.1.0, origin/main',
    author: 'Code Scribes <hello@codescribes.io>',
    date: 'July 10, 2025',
    message: 'Initial commit'
  },
  // Physical dimensions are deliberately absent -- they were never recorded,
  // and a made-up size is the one spec a sticker buyer would notice was wrong.
  spec: [
    { label: 'MATERIAL', value: 'Premium die-cut vinyl' },
    { label: 'FINISH', value: 'Durable and weather resistant' },
    { label: 'RUN', value: 'Limited to 500' },
    { label: 'PRINTED BY', value: 'StickerMule' }
  ],
  nextDropHeading: 'Drop 002 is already on the bench',
  nextDropBlurb: 'Get told when the latest merch drops, and nothing else.'
};


/**
 * Whether the store is open and where its buy button points.
 *
 * Returns null until it resolves, and a closed store if it can't. Failing
 * closed is deliberate: the cost of wrongly hiding a launched store for a
 * moment is far lower than the cost of flashing an unlaunched one. In practice
 * the same process serves this and the page itself, so if it is unreachable
 * the app was not going to load anyway.
 */
const useMerchConfig = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let cancelled = false;

    api.config.getConfig()
      .then((data) => { if (!cancelled) setConfig(data); })
      .catch(() => { if (!cancelled) setConfig({ showMerchPage: false, paymentLinkUrl: null }); });

    return () => { cancelled = true; };
  }, []);

  return config;
};


const MerchPage = () => {
  const config = useMerchConfig();

  // Render nothing until it resolves rather than guessing. Either guess would
  // flash the wrong page, and one of those leaks a store that has not
  // launched.
  if (config === null) {
    return null;
  }

  // The server will not report an open store without a checkout URL, so the
  // buy button cannot render pointing at nothing.
  return config.showMerchPage
    ? <Drop {...INITIAL_COMMIT} checkoutUrl={config.paymentLinkUrl} />
    : <ComingSoon />;
};

export default MerchPage;
